export default "images/in-a-hurry.png";